import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"



// Components
import PackageDetalisPopUp from "./packageDetalisPopUp.vue"

// Props
interface Props {
	top?: string
	left?: string
	additionalClasses?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PackageDetailsTooltip',
  props: {
    top: {},
    left: {},
    additionalClasses: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit // Strongly type the emitted event

const handleClick = (): void => {
	emit("click")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([props.additionalClasses, "d-inline pe-1 position-relative"])
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: "info-icon icon tf-icon-10 tf-icon-sm-20",
      onClick: _withModifiers(handleClick, ["stop"])
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("use", { "xlink:href": "#___icon___info" }, null, -1)
    ]))),
    _createVNode(PackageDetalisPopUp, {
      top: '0',
      left: '10px'
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ], 2))
}
}

})